import isFunction from 'lodash/isFunction';

import './modal.scss';

class ModalCtrl {
    constructor($sce, imagesService) {
        this.$sce = $sce;
        this.imagesService = imagesService;
    }

    onInit() {
        this.$sce.trustAsHtml(this.modalData.modalContent);
    }

    onModalClose() {
        if (isFunction(this.onCloseCallback)) {
            this.onCloseCallback();
        }
    }
}

ModalCtrl.$inject = ['$sce', 'imagesService'];

export default ModalCtrl;